<template>
  <div class="fixed top-0 right-0 m-6 z-50">
    <transition name="slide-fade">
      <div
        v-if="message"
        class="rounded-lg shadow-md p-3 pr-4 text-sm break-words w-64"
        :class="this.categorizedColors"
      >
        <button
          class="opacity-75 cursor-pointer absolute top-0 right-0 py-2 px-3 hover:opacity-100"
          @click.prevent="close"
        >
          &times;
        </button>
        <div class="flex items-center">
          {{ message.text }}
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      message: null
    };
  },
  computed: {
    category() {
      if (!this.message.type) return 'info';
      
      return this.message.type;
    },
    categorizedColors() {
      switch (this.category) {
        case 'danger':
          return 'bg-destructive text-white';
      
        default:
          return 'bg-primary-lightest text-primary-darkest';
      }
    }
  },
  mounted() {
    let timer;
    Event.$on('toast', message => {
        clearTimeout(timer);
        this.message = message;
        const duration = message.duration || 3;

        timer = setTimeout(() => {
            this.message = null;
        }, duration * 1000);
    });
  },
  methods: {
        close() {
            this.message = null;
        }
  }
};
</script>

<style scoped>
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.4s;
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(400px);
  opacity: 0;
}
</style>